var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "glazing-options" },
    [
      _c("tab-heading", _vm._g({}, _vm.$listeners), [
        _c("h2", { staticClass: "text-center" }, [_vm._v("Glazing Options")]),
        _c("p", { staticClass: "lead text-center mb-1" }, [
          _vm._v("Choose a glazing below:"),
        ]),
        _c("p", { staticClass: "text-center font-italic mb-0" }, [
          _vm._v(
            "If you choose glazing, backing board will automatically be added to your frame."
          ),
        ]),
      ]),
      _c(
        "b-alert",
        {
          staticClass: "mt-3",
          attrs: {
            variant: _vm.selectedGlazing == null ? "danger" : "warning",
            show: _vm.hasMount,
          },
        },
        [
          _vm._v("We require that you have "),
          _c("strong", [_vm._v("glazing")]),
          _vm._v(" in your frame if you have chosen a mount."),
        ]
      ),
      _c(
        "b-row",
        { staticClass: "mb-1 py-3" },
        [
          _c("b-col", { attrs: { sm: "3" } }, [
            _c(
              "h4",
              {
                staticClass: "border-left p-3 glazing-type",
                class: { "border-primary": _vm.selectedType == null },
              },
              [_vm._v("None")]
            ),
          ]),
          _c(
            "b-col",
            [
              _c(
                "b-row",
                { staticClass: "mb-3 ml-3 ml-sm-0" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-radio",
                        {
                          attrs: { value: null },
                          model: {
                            value: _vm.selectedGlazing,
                            callback: function ($$v) {
                              _vm.selectedGlazing = $$v
                            },
                            expression: "selectedGlazing",
                          },
                        },
                        [_vm._v("No Glazing")]
                      ),
                      _c("p", { staticClass: "my-2" }, [
                        _c("small", [
                          _vm._v("No glazing will be added to your order"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c("b-col", { staticClass: "text-right" }, [_vm._v("£0.00")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.glazingOptions, function (options, type) {
        return _c(
          "b-row",
          { key: type, staticClass: "mb-1 py-3" },
          [
            _c("b-col", { attrs: { sm: "3" } }, [
              _c(
                "h4",
                {
                  staticClass: "border-left p-3 glazing-type",
                  class: { "border-primary": _vm.selectedType == type },
                },
                [_vm._v(_vm._s(type))]
              ),
            ]),
            _c(
              "b-col",
              _vm._l(options, function (glazing, idx) {
                return _c(
                  "glazing-option-component",
                  {
                    key: `${type}-${idx}`,
                    staticClass: "ml-3 ml-sm-0",
                    attrs: {
                      glazing: glazing,
                      "rebate-dimensions": _vm.rebateDimensions,
                    },
                  },
                  [
                    _c(
                      "b-form-radio",
                      {
                        attrs: { value: glazing },
                        model: {
                          value: _vm.selectedGlazing,
                          callback: function ($$v) {
                            _vm.selectedGlazing = $$v
                          },
                          expression: "selectedGlazing",
                        },
                      },
                      [_vm._v(_vm._s(glazing.name))]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }